/** Format a mobile number for it to be usable as a product access number. */
export function normalizeMsisdn(msisdn: string): string {
  if (msisdn.length > 10 && msisdn.startsWith('32')) {
    msisdn = msisdn.slice(2);
  }
  return msisdn.padStart(10, '0');
}
